module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"hu":{"title":"Események","p1":"Jelenleg nem várható esemény.","p2":{"1":"Új események bejelentéséig látogass el ","2":"Facebook oldalunkra"}},"en":{"title":"Events","p1":"No upcoming events available.","p2":{"1":"Until new events are announced, visit our ","2":"Facebook page"}}}')
  delete Component.options._Ctor
}
